import React from "react";
import { NavLink } from 'react-router-dom'
import { CCard, CCardHeader, CCardBody, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CListGroup, CListGroupItem } from '@coreui/react'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { codeSnippet } from '../../utils/codeSnippet/db/dynamoDb';

function DbDashboard () {

  return (
    <CCard className="mb-4">
      <CCardHeader><strong>Dashboard</strong></CCardHeader>
			<CCardBody>
				<p><b>Serverless Architecture</b> - Fully managed with no servers to provision, patch, or manage. AWS handles all infrastructure operations.</p>
				<p><b>Performance at Scale</b> - Provides consistent single-digit millisecond latency for both read and write operations, even at massive scale.</p>
				<p><b>Flexible Data Model </b>- Supports both document and key-value data structures, allowing you to store and retrieve any amount of data.</p>
				<p><b>Auto Scaling </b>- Automatically adjusts read and write capacity based on traffic patterns.</p>
				<p><b>On-Demand Billing </b>- Pay only for what you use with on-demand capacity mode, or use provisioned capacity for predictable workloads.</p>
				<p><b>Secondary Indexes</b> - Global Secondary Indexes (GSI) and Local Secondary Indexes (LSI) for flexible querying patterns.</p>
				<p><b>Multi-Region Replication </b>- Global Tables use asynchronous replication between regions with conflict resolution using "last writer wins" with timestamps.</p>
				<p><b></b> </p>
				<p><b></b> </p>
				<CAccordion flush>
				<CAccordionItem itemKey={1}>
						<CAccordionHeader>Architecture</CAccordionHeader>
						<CAccordionBody>   	
							<p></p>						
							<ol>
								<li>
									<p><b>Partition Key:</b></p>
									<ul>
										<li>
											<p>The partition key is used by DynamoDB's internal hash function to determine which physical partition will store your data item.</p>
											<p>In a table with only a partition key (simple primary key), this value must be unique across all items in the table.</p>
											<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code1}</SyntaxHighlighter>
											<p><b>Composite Primary Key - Consists of partition key + sort key</b></p>
											<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code2}</SyntaxHighlighter>

											</li>
									</ul>	
								</li>
								<li>
									<p><b>Sort Key: (range key)</b></p>
									<ul>
										<li>
											<p>Works together with the partition key to uniquely identify each item in the table.</p>
											<p>Items with the same partition key are physically stored in sorted order based on the sort key value.</p>
											</li>
									</ul>	
								</li>
								<li>
									<p><b>Global Secondary Index</b></p>
									<ul>
										<li>
											<p>A Global Secondary Index (GSI) is an alternate access pattern for your DynamoDB table that allows you to query data using different partition and sort keys than your main table.</p>
											<p>The key insight is that GSIs reorganize your data in a way that makes certain queries efficient, rather than forcing you to scan through all data to find what you need.</p>
											<p>GSIs provide a different way to access your data without having to scan the entire table.</p>
											<p>Each GSI has its own provisioned throughput capacity, separate from the main table.</p>
											<p>Limit: Up to 20 Global Secondary Indexes per table</p>
											</li>
									</ul>	
								</li>
							</ol>
							<img src="" width="50%" height="50%" /><br/><br/>  							
						</CAccordionBody>
				</CAccordionItem>
				<CAccordionItem itemKey={2}>
						<CAccordionHeader>Code</CAccordionHeader>
						<CAccordionBody>   	
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code3}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code4}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code5}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code6}</SyntaxHighlighter>
							<SyntaxHighlighter wrapLines="true" language="javascript" style={docco}>{codeSnippet.code7}</SyntaxHighlighter>
						</CAccordionBody>
				</CAccordionItem>							
				</CAccordion>
			</CCardBody>
    </CCard>        
  )
}

export default DbDashboard;